/**
 * Deal / voucher pay-at-store price formatter.
 * Spec: WEB_SPEC_PAY_AT_STORE_AND_UPDATE3 §1.2
 *
 * Inputs (any of price / original_value / price_label may be null):
 *   price:         number|null — what the customer pays the store
 *   original_value: number|null — crossed-out full value
 *   price_label:   string|null — textual price when no numeric price
 *
 * Returns:
 *   {
 *     payLine:      string|null  // e.g. "Pay at the store: $34 (normally $69)"
 *     amountLabel:  string|null  // e.g. "$34" — the bare price string
 *     originalLabel:string|null  // e.g. "$69" — bare original value string (only when shown)
 *     collectLine:  string|null  // e.g. "Collect $34 from the customer" (vendor view)
 *   }
 * All null → hide the payment row entirely (legacy vouchers).
 */
export function formatDealPrice(v) {
  if (!v) return { payLine: null, amountLabel: null, originalLabel: null, collectLine: null };
  const { price, original_value: original, price_label } = v;

  if (price != null && Number.isFinite(Number(price)) && Number(price) > 0) {
    const p = Number(price);
    const amountLabel = money(p);
    const showOriginal = original != null && Number(original) > p;
    const originalLabel = showOriginal ? money(Number(original)) : null;
    const payLine = showOriginal
      ? `Pay at the store: ${amountLabel} (normally ${originalLabel})`
      : `Pay at the store: ${amountLabel}`;
    const collectLine = `Collect ${amountLabel} from the customer`;
    return { payLine, amountLabel, originalLabel, collectLine };
  }

  if (price_label) {
    return { payLine: price_label, amountLabel: price_label, originalLabel: null, collectLine: null };
  }

  return { payLine: null, amountLabel: null, originalLabel: null, collectLine: null };
}

/** "$34" or "$34.50" — no trailing .0, NZD assumed (spec omits currency prefix). */
export function money(n) {
  if (!Number.isFinite(n)) return "$0";
  const rounded = Math.round(n * 100) / 100;
  const s = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2).replace(/\.?0+$/, "");
  return `$${s}`;
}
